<template>
    <div class="property-grid">
        <section v-for="group in groups" :key="group.title || 'default'" class="property-group">
            <h6 v-if="group.title" class="property-group-title">{{ group.title }}</h6>
            <dl class="property-cells">
                <div v-for="field in group.fields" :key="field.name" class="property-cell"
                    :class="{ 'is-wide': field.type === 'textarea' }">
                    <dt>{{ field.label }}</dt>
                    <dd :class="{ 'is-empty': isEmpty(field), 'is-mono': monoFields.includes(field.name) }">
                        <router-link v-if="links[field.name] && !isEmpty(field)" :to="links[field.name]">
                            {{ display(field) }}<i class="fa fa-arrow-right"></i>
                        </router-link>
                        <template v-else>{{ display(field) }}</template>
                    </dd>
                </div>
            </dl>
        </section>
    </div>
</template>
<script>
export default {
    name: "PropertyGrid",
    props: {
        groups: { type: Array, required: true },
        record: { type: Object, default: () => ({}) },
        links: { type: Object, default: () => ({}) },
        monoFields: { type: Array, default: () => [] }
    },
    methods: {
        rawValue(field) {
            return field.name.split('.').reduce((obj, key) => (obj == null ? obj : obj[key]), this.record);
        },
        optionLabel(field, value) {
            const option = (field.options || []).find((item) => item.value == value);
            return option && option.value != null ? option.label : null;
        },
        display(field) {
            const value = this.rawValue(field);
            if (field.options) return this.optionLabel(field, value) || '—';
            if (value === null || value === undefined || value === '') return '—';
            return value;
        },
        isEmpty(field) {
            return this.display(field) === '—';
        }
    }
};
</script>
<style lang="scss">
@use '../../theme/scss/_user-variables.scss' as *;

.property-group + .property-group {
    border-top: 1px solid $gray-200;
}

.property-group-title {
    margin: 0;
    padding: 0.85rem 1.5rem 0;
    font-size: 0.65rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: $gray-600;
}

.property-cells {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(11rem, 1fr));
    margin: 0;
    padding: 0.35rem 0.75rem 0.6rem;
}

.property-cell {
    min-width: 0;
    padding: 0.55rem 0.75rem;

    &.is-wide {
        grid-column: 1 / -1;
    }

    dt {
        margin-bottom: 0.2rem;
        font-size: 0.75rem;
        font-weight: 400;
        color: $gray-700;
    }

    dd {
        margin: 0;
        font-size: 0.9rem;
        font-weight: 500;
        color: #12263f;
        overflow-wrap: anywhere;

        &.is-empty {
            color: $gray-500;
            font-weight: 400;
        }

        &.is-mono {
            font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
            font-size: 0.8125rem;
        }

        a {
            display: inline-flex;
            align-items: center;
            gap: 0.35rem;

            i {
                font-size: 0.6rem;
                transition: transform 0.15s ease;
            }

            &:hover i {
                transform: translateX(2px);
            }
        }
    }

    &.is-wide dd {
        font-weight: 400;
        line-height: 1.55;
        color: $gray-800;
        white-space: pre-line;
    }
}

body.dark-mode {
    .property-group + .property-group {
        border-color: $dark-border-color;
    }

    .property-group-title,
    .property-cell dt,
    .property-cell dd.is-empty {
        color: $dark-text-muted;
    }

    .property-cell dd,
    .property-cell.is-wide dd {
        color: $dark-text-primary;
    }
}
</style>
